export const isUrlValid = (url: string): boolean => {
  try {
    return Boolean(new URL(url));
  } catch (err) {
    return false;
  }
};
